import { type ReactNode } from 'react';

/**
 * Converts markup string to JSX spans.
 * Supports:
 *   **bold** → <strong>
 *   _italic_ → <em>
 * Does NOT support nesting.
 */
export function RichText({ text }: { text: string }): ReactNode {
  const parts: ReactNode[] = [];
  const regex = /(\*\*(.+?)\*\*)|(_.+?_)/g;

  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[1]) {
      parts.push(<strong key={match.index}>{match[2]}</strong>);
    } else if (match[3]) {
      parts.push(<em key={match.index}>{match[3].slice(1, -1)}</em>);
    }
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  if (parts.length === 0) return text;
  if (parts.length === 1 && typeof parts[0] === 'string') return parts[0];
  return <>{parts}</>;
}
